import CloseIcon from "@mui/icons-material/Close";
import { Button, ButtonGroup, TextField, Dialog } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import Currencies from "../../root/currency";
import CurrencyCashConfig from "../../root/CurrencyCashConfig";


const CashPaymentDialog = ({
  handlePayMode,
  setCashPayDialog,
  totalAmount,
  order,
  cashout
}) => {
  const [cashAmount, setCashAmount] = useState(0);
  const [otherAmount, setOtherAmount] = useState(0);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [changeDue, setChangeDue] = useState(totalAmount);
  const { formatMessage: t, locale } = useIntl();
  const [payConfirmDialog, setPayConfirmDialog] = useState(false);
  let merchantData = sessionStorage.getItem("merchantData")
    ? JSON.parse(sessionStorage.getItem("merchantData"))
    : null;
  const formatter = new Intl.NumberFormat(localStorage.getItem("locale") || 'en-US', {
    style: 'currency',
    currency: merchantData?.currency || 'USD'
  });
  let userData = window.localStorage.getItem("userData")
    ? JSON.parse(window.localStorage.getItem("userData"))
    : "";
  const handleOtherPaymentSelection = (index) => {
    setSelectedMethod(index);

  };

  const handleCashAmountChange = (e) => {
    const newCashAmount = e.target.value;
    setCashAmount(newCashAmount);
    calculateChangeDue(newCashAmount, otherAmount);
  };

  const handleOtherAmountChange = (e) => {
    const newOtherAmount = e.target.value;
    setOtherAmount(newOtherAmount);
    calculateChangeDue(cashAmount, newOtherAmount);
  };



  const calculateChangeDue = (cashAmount, otherAmount) => {
    const paidAmount =
      (parseFloat(cashAmount) || 0) + (parseFloat(otherAmount) || 0);
    const change = totalAmount - paidAmount;
    setChangeDue(change.toFixed(2));
  };
  // const merchantData = JSON.parse(sessionStorage.getItem("merchantData"));
  // const currencyCode = merchantData?.currency || "USD";
  // const currencyObj = Currencies.find(c => c.abbreviation === currencyCode);
  // const currencySymbol = currencyObj?.symbol || currencyCode;

  const handleNextClick = () => {
    let secondMode = ""
    if (selectedMethod == 1) {
      secondMode = "upi";
    }
    else if (selectedMethod == 2) {
      secondMode = "card";
    } else if (selectedMethod == 3) {
      secondMode = "coupon";
    } else if (selectedMethod == 4) {
      secondMode = "credit";
    }
    console.log(secondMode);
    console.log(otherAmount);
    handlePayMode("CASH", "", "", secondMode, otherAmount);
    //handlePayMode("CASH", order, "",);
    setCashPayDialog(false);
  };
  // const denominations = [1, 2, 5, 10, 20, 50, 100, 200, 500];
  const encodeQueryData = (data) => {
    const ret = [];
    for (let d in data)
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
    return ret.join('&');
  }
  const purchase_tx = () => {

    const merchantId = userData.merchantCode;
    //const amount = parseFloat(order.totalPrice);



    if (userData?.paymentProviderType.toLowerCase() == 'fygaro') {

      setPayConfirmDialog(`https://www.fygaro.com/en/pb/${userData?.paymentProviderCode}/+?amount=${order.totalPrice}&client_note=digifyPoS&client_reference=${order?.invoicePath || new Date().getTime()}&return_url=https://www.fygaro.com/`);
    } else if (userData?.paymentProviderType.toLowerCase() == 'verifone') {
      let data = {
        amount: parseFloat(otherAmount || 0) + parseFloat(cashout || 0),
        cash_amount: parseFloat(cashout || 0),
        reference_id: Math.random().toString(36).substring(2, 10),
        register_id: userData?.firstName || userData.name,
        merchant_id: merchantId
      };
      console.log(data);
      let queryStr = encodeQueryData(data);
      setPayConfirmDialog('https://vcloud.alt-payment.com/webint/purchase/NextOrder?' + queryStr);
      // $('#myModal').modal('show');
    }
  }

  const orderCurrency = order?.currency;
  const currencyCode =
    (orderCurrency && orderCurrency.toUpperCase()) ||
    (merchantData?.currency && merchantData.currency.toUpperCase()) ||
    "USD";


  const getCurrencySymbol = () => {
    const cur = Currencies.filter(
      (curen) => curen.abbreviation === currencyCode
    );
    return cur.length ? cur[0].symbol : currencyCode;
  };

  const currencySymbol = getCurrencySymbol();


  const rawDenominations = [
    ...(CurrencyCashConfig[currencyCode]?.coins || []),
    ...(CurrencyCashConfig[currencyCode]?.notes || [])
  ];

  const extractNumber = (label) => {
    const match = label.match(/[\d.]+/);
    return match ? Number(match[0]) : 0;
  };
  const handleAddCash = (value, isReplace) => {
    const newCash = isReplace ? value : parseFloat(cashAmount || 0) + value;
    setCashAmount(newCash);
    calculateChangeDue(newCash, otherAmount);
  };

  const event_handler2 = (event) => {
    try {
      console.info('EVENT: Received event cashpaymet -----');

      var data;
      data = event.data;
      console.log(data);

      if (data && typeof data == 'string' && (JSON.parse(data)?.result == "FAILURE" || JSON.parse(data)?.result == "CANCELLED" || JSON.parse(data)?.result == "NOCONNECTION" || JSON.parse(data)?.result == "SUCCESS")) {
        setPayConfirmDialog(false);
      }


    }
    catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    //if (userData?.paymentProviderType?.toLowerCase() == 'verifone') {
    window.addEventListener('message', (event) => event_handler2(event), false);
    //}
  }, []);

  return (
    <div id="cash-dialog">
      <DialogTitle sx={{ m: 0, p: 2 }}>
        <b>{t({ id: "cash_change" })}</b>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => setCashPayDialog(false)}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent
        style={{
          borderTop: "1px solid #ccc",
          borderBottom: "1px solid #ccc",
          padding: "0px 20px",
        }}
      >
        <div className={"dialog-row"}>
          <label>{t({ id: "bill_amount" })}:</label>
          <h2>
            <b>{formatter.format(totalAmount).replace('JMD', 'J$').replace(/\s+/, "")}</b>
          </h2>
        </div>
        <div className={"dialog-row"}>
          <label>{t({ id: "paid_by_cash" })}:</label>

          <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
            <div> <TextField
              variant="outlined"
              type="number"
              size="small"
              value={cashAmount}
              onChange={(e) => (setCashAmount(e.target.value), handleAddCash(e.target.value, true))}
              style={{ width: "150px" }}
            />
              <Button
                variant="outlined"
                color="error"
                style={{ marginTop: "10px" }}
                onClick={() => {
                  setCashAmount(0);
                  calculateChangeDue(0, otherAmount);
                }}
              >
                Clear
              </Button></div>
            <div style={{ marginTop: "1px" }}>
              {/* Coins */}
              {false && CurrencyCashConfig[currencyCode]?.coins && (
                <>
                  <label style={{ fontWeight: "bold" }}>Coins:</label>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                    {CurrencyCashConfig[currencyCode].coins.map((label, index) => (
                      <Button
                        key={`coin-${index}`}
                        style={{ backgroundColor: "#000" }}
                        variant="contained"
                        onClick={() => handleAddCash(extractNumber(label))}
                      >
                        {label}
                      </Button>
                    ))}
                  </div>
                </>
              )}

              {/* Notes */}
              {CurrencyCashConfig[currencyCode]?.notes && (
                <>
                  {false && <label style={{ fontWeight: "bold" }}>Notes:</label>}
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                    {CurrencyCashConfig[currencyCode].notes.map((label, index) => (
                      <Button
                        key={`note-${index}`}
                        variant="contained"

                        style={{ backgroundColor: "#000" }}
                        onClick={() => handleAddCash(extractNumber(label))}
                      >
                        {label}
                      </Button>
                    ))}
                  </div>
                </>
              )}
            </div>



          </div>
        </div>


        <div className={"dialog-row"} style={{ marginTop: "10px", justifyContent: "space-between" }}>
          <label>{t({ id: "split_pay_by" })}</label>
          <ButtonGroup style={{ textAlign: "left" }}>
            {[
              { id: 1, label: "QR/SCAN", value: "1" },
              { id: 2, label: "CARD", value: "2" },
              { id: 3, label: "COUPON", value: "3" },
              { id: 4, label: "CREDIT", value: "4" }
            ]
              .filter(method => (merchantData?.paymentMethods ? merchantData.paymentMethods.split(",") : ["0", "1", "2"]).includes(method.value))
              .map((method) => (
                <Button
                  key={method.id}
                  variant={selectedMethod === method.id ? "contained" : "outlined"}
                  onClick={() => handleOtherPaymentSelection(method.id)}
                >
                  {method.label}
                </Button>
              ))}
          </ButtonGroup>
          {selectedMethod && (
            <TextField
              variant="outlined"
              type="number"
              size="small"
              value={otherAmount}
              onChange={handleOtherAmountChange}
              style={{ width: "120px", margin: "0px 10px", minWidth: "100px" }}
            />
          )}
          {selectedMethod && <img
            height="auto"
            width="70px"
            alt=""
            style={{ height: "auto", cursor: "pointer" }}
            src={"/swiping.svg"}
            onClick={() => purchase_tx()}
          />}
        </div>
        <div className={"dialog-row"}>
          <label>{t({ id: "change_due" })}<br /><span style={{ fontSize: '10px' }}>{'Note: -(Minus) Means, return amount'}</span>:</label>

          <h2 style={{ color: changeDue > 0 ? "red" : "green" }}>
            <b>{formatter.format(changeDue).replace('JMD', 'J$').replace(/\s+/, "")}</b>
          </h2>
        </div>
      </DialogContent >
      <DialogActions>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "10px",
            width: "100%",
          }}
        >
          <Button
            variant="outlined"
            color="error"
            onClick={() => setCashPayDialog(false)}
          >
            {t({ id: "cancel" })}
          </Button>
          <Button
            variant="contained"
            onClick={handleNextClick}
            disabled={parseFloat(changeDue) > 0 || parseFloat(cashAmount) < 1}
          >
            {t({ id: "Next" })}
          </Button>
        </div>
      </DialogActions>
      <Dialog
        open={payConfirmDialog}
        style={{ zIndex: 9999999 }}
      >
        <div class="modal-body" style={{ height: "600px" }}>
          <iframe id="txFrame" src={payConfirmDialog} frameborder="0" allowtransparency="true" style={{ width: "100%", height: "100%" }}></iframe>
        </div>
      </Dialog>
    </div >

  );
};

export default CashPaymentDialog;
